import styled from 'styled-components';
export const Container = styled.div`
    position: fixed;
    display: ${({isOpen}) => isOpen ?'flex':'none'};
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999999999999999;
    background-color: rgba(0,0,0,.45);

    animation: ModalShow .1s ease-out;

    @keyframes ModalShow{
      0% {
        opacity: 0;
        transform: scale(1.2);
      }
      100% {
        opacity: 0;
        transform: scale(1);
      }
    }
` 
export const Content = styled.div`
   display: flex;
   width: 30rem;
   min-width:300px;
   height: 25rem;
   flex-direction: column;   
` 
export const Header = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    flex: 3;
    padding: 0.5rem;
    justify-content:end;
    align-items: flex-start;
    border-radius: 10px 10px 0px 0px ;
    background: transparent linear-gradient(325deg, #1D86FF 0%, #7EF6B7 100%) 0% 0% no-repeat padding-box;

    .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        border-radius: 50%;
        transition: background-color 1s;
        font-size: 2.5rem;

        &:hover{
            background-color: rgba(0,0,0,.1);
        }
    }

`
export const Body = styled.div`
    display: flex;
    width: 100%;
    flex: 8;
    align-items: center;
    border-radius: 0px 0px 10px 10px ;
    padding: 0.5rem;
    flex-direction: column;
    background-color: #ffff;
`
export const AvatarArea = styled.div`
    display: flex;
    width:8rem;
    height: 8rem;
    margin-top: -4rem;
    z-index: 9999;
    border-radius: 50%;
    padding: 0.2rem;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
`
export const Description = styled.div`
    margin-top: 0.75rem;
    span{
        font-size: 1.2rem;
        font-weight: 500;
    }
`
export const Line = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: auto;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    padding: 0rem 1rem 1rem;
    gap: 0.5rem;

    label{
        font-size: 1.1rem;
        font-weight:bold;
    }
    .accessibility{
        display: flex;
        justify-content: space-between;
        span{
          color: #000000;
          font-weight: 500;
        }  
        .switch {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 23px;
        }

        .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
        }

        .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0px;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
        }

        .slider:before {
            position: absolute;
            content: "";
            height: 16px;
            width: 16px;
            left: 3px;
            bottom: 4px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
        }

        input:checked + .slider {
        background-color: #2196F3;
        }

        input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
        }

        input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
        }

        /* Rounded sliders */
        .slider.round {
        border-radius: 34px;
        }

        .slider.round:before {
        border-radius: 50%;
        }

    }
`
export const Actions = styled.div`
    display: flex;
    width: 100%;
    height: 4rem;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: end;
    padding: 0rem 1rem;
`
export const Input = styled.input`
    outline: none;
    border: none;
    width: 100%;
    padding: 5px 12px;
    font-size: 14px;
    line-height: 20px;
    border: 1px solid #d0d7de;
    border-radius: 6px;
    background-color: #f6f8fa;
    pointer-events: ${({loading}) => loading ? 'none' : 'auto'};

`
export const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    border: 1px solid  #1c83e3;
    border-radius: 6px;
    width: 5rem;
    height: 2rem;
    color:#ffffff;
    background-color: #1c83e3;
    cursor: pointer;

    pointer-events: ${({loading}) => loading ? 'none' : 'auto'};


    &:hover{
        filter:brightness(0.9)
    }

`
export const Load = styled.div`
    border: 2px solid #fff; 
    border-top: 2px solid #0000; 
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    margin-left: 2px;
  
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`
